export enum DataAccelerationStatus {
    CanBeAccelerated = 'CanBeAccelerated',
    Accelerated = 'Accelerated',
    CannotBeAccelerated = 'CannotBeAccelerated',
}
